import * as React from 'react';
import { ConsentsContainer } from '../containers/ConsentsContainer.js';
import { CreateAccountContainer } from '../containers/CreateAccountContainer.js';
import { OptInsContainer } from '../containers/OptInsContainer.js';

const Consents = ({ handleOptInsLoading  })=>/*#__PURE__*/ React.createElement("div", {
        className: "checkout__checkboxes"
    }, /*#__PURE__*/ React.createElement(CreateAccountContainer, null), /*#__PURE__*/ React.createElement(OptInsContainer, {
        handleOptInsLoading: handleOptInsLoading
    }), /*#__PURE__*/ React.createElement(ConsentsContainer, null))
;

export { Consents };
//# sourceMappingURL=Consents.js.map
